function Combobox() {
  const comboboxes = Array.from(document.querySelectorAll('.c-combobox'));

  comboboxes.forEach(function (combobox) {
    const input = combobox.querySelector('.c-combobox__input');
    const select = combobox.querySelector('.c-combobox__select');
    const options = Array.from(select.querySelectorAll('li[role="option"]'));

    // Set initial state
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-owns', select.id);
    input.setAttribute('aria-controls', select.id);

    // Event listeners
    input.addEventListener('focus', function () {
      input.setAttribute('aria-expanded', 'true');
      select.setAttribute('aria-expanded', 'true');
    });

    input.addEventListener('blur', function () {
      input.setAttribute('aria-expanded', 'false');
      select.setAttribute('aria-expanded', 'false');
    });

    input.addEventListener('input', function () {
      const inputValue = input.value.toLowerCase();

      options.forEach(function (option) {
        const optionText = option.textContent.toLowerCase();

        if (optionText.includes(inputValue)) {
          option.style.display = '';
          option.setAttribute('aria-hidden', 'false');
        } else {
          option.style.display = 'none';
          option.setAttribute('aria-hidden', 'true');
        }
      });
    });

    select.addEventListener('click', function (event) {
      const target = event.target;
      const isOption = target.getAttribute('role') === 'option';

      if (isOption) {
        const selectedOption = select.querySelector('[aria-selected="true"]');
        if (selectedOption) {
          selectedOption.setAttribute('aria-selected', 'false');
        }

        target.setAttribute('aria-selected', 'true');
        input.value = target.textContent;

        input.focus();
      }
    });

    // Display options initially
    options.forEach(function (option) {
      option.style.display = '';
      option.setAttribute('aria-hidden', 'false');
    });
  });
}

export default Combobox;
